<template>
  <div>
    <div class="payment">
      <div
        data-testid="balance-information-container"
        class="content-balance mb-2"
      >
        <!--Balance overview-->
        <balance-overview />
        <!--/ Balance overview-->
      </div>

      <div
        data-testid="tabs-history-container"
        class="tabs-history"
      >
        <!--History-->
        <tabs-history />
        <!--/ History-->
      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import envMixin from '@/mixins/envMixin'
import stepGuideMixin from '@/mixins/stepGuideMixin'
import authMixin from '@/mixins/authMixin'
import BalanceOverview from './components/BalanceOverview.vue'
import TabsHistory from './components/TabsHistory/TabsHistory.vue'

const { mapGetters } = createNamespacedHelpers('payment')
const { mapGetters: mapGettersAuth } = createNamespacedHelpers('auth')
const { mapGetters: mapGettersPayment, mapActions } = createNamespacedHelpers(
  'payment',
)

export default {
  components: {
    TabsHistory,
    BalanceOverview,
    // components
  },
  mixins: [envMixin, stepGuideMixin, authMixin],

  data() {
    return {
      // showBalanceAllowCation: false,
      linkDetail:
        'https://ecomdycom.larksuite.com/docx/NA9LdCbBNo2IQFxXCkluRequsGe',
    }
  },

  computed: {
    ...mapGetters(['status', 'listBusinessAccountHistoryLimit', 'loading']),
    ...mapGettersAuth(['user']),
    ...mapGettersPayment(['listUsedPaymentMethods']),
  },

  watch: {
    //   $route: {
    //     immediate: true,
    //     handler(val) {
    //       if (val.query?.type === 'show_balance') {
    //         this.showBalance()
    //       }
    //     },
  },

  created() {
    this.fetchListUsedPaymentMethods()
  },

  methods: {
    ...mapActions(['getListUsedPaymentMethods']),

    // showBalance() {
    //   this.showBalanceAllowCation = true
    // },

    async fetchListUsedPaymentMethods() {
      await this.getListUsedPaymentMethods()
    },
  },
}
</script>

<style lang="scss" scoped>
.notification-refund-policy {
  cursor: pointer;
  background: rgba(38, 103, 255, 0.1) !important;

  .title-notification {
    margin-bottom: 0.5rem;

    display: flex;
    align-items: center;

    .ic-docs {
      margin-right: 5px;
    }

    .ic-notification {
      margin-left: 6px;
      color: #2667ff;
    }
  }
}
</style>
